import "./PawnParkService.css";
import { Helmet } from "react-helmet-async";

const title = "Pawn & Park Service";
const pageTitle = "Pawn & Park Service | Respected Solutions";
const metaDescription =
  "Introducing Pawn & Park: A First-of-Its-Kind Service from Respected Solutions. Get a loan using your car as collateral and enjoy free secure storage. Car storage loan Lagos, pawn and park Abuja, park and collect loan Nigeria at Respected Solutions.";

const PawnParkService = () => {
  return (
    <section className="pawn-park-container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Pawn & Park Service",
            provider: {
              "@type": "Organization",
              name: "Respected Solutions",
            },
            areaServed: ["Lagos", "Abuja", "NG"],
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Pawn & Park Service",
            url: "https://www.respectedsolution.co/pawn-park-service",
          })}
        </script>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="pawn-park-hero-slide"
        style={{ backgroundImage: `url(/assets/images/rs/car_loans.jpg)` }}
      >
        <div className="pawn-park-hero-overlay">
          <div className="pawn-park-hero-content">
            <h1>{title}</h1>
            <p>Quick loans + free, safe storage.</p>
          </div>
        </div>
      </div>

      <div className="pawn-park-inner">
        <div className="pawn-park-inner-content">
          <section className="pawn-park-intro">
            <h3>
              Introducing Pawn & Park: A First-of-Its-Kind Service from
              Respected Solutions
            </h3>
            <p>
              At Respected Solutions, we're always looking for innovative ways
              to serve you better. That's why we're proud to introduce a service
              that puts your convenience and peace of mind first:{" "}
              <strong>Pawn & Park</strong>.
            </p>
            <p>
              Available in Lagos and Abuja, our pawn and park service combines
              instant cash loans with secure car parking facilities, giving you
              the flexibility you need when you need it most.
            </p>
          </section>

          <section className="pawn-park-meaning">
            <h2>What Does Pawn & Park Mean?</h2>
            <p>
              <strong>Pawn:</strong> To <em>pawn</em> an item simply means using
              it as collateral to access a loan. You bring in something valuable
              such as a car, jewelry, a luxury wristwatch, or a high-end gadget,
              and we give you quick cash while keeping your item safe until your
              loan is fully repaid. Once repayment is complete, your item is
              returned to you in the same condition.
            </p>
            <p>
              <strong>Park:</strong> To park means leaving your fully repaid
              item with us in secure storage for as long as you need. With{" "}
              <strong>Pawn & Park</strong>, you don't have to rush back the
              moment your loan is settled. Instead,{" "}
              <strong>
                you can safely park your valuables with us at no cost, until
                you're ready to collect them
              </strong>
              .
            </p>
            <p>
              Together, this service combines quick loans with free, safe
              storage... a unique solution designed with your lifestyle in mind.
            </p>
          </section>

          <section className="pawn-park-how">
            <h2>How the New Pawn & Park Works</h2>
            <ul>
              <li>
                <strong>1. Pawn Your Valuables - </strong> Bring in items like
                cars, jewelry, luxury wristwatches, or high-end gadgets. We'll
                value them transparently and give you quick access to cash.
              </li>
              <li>
                <strong>2. Repay Your Loan - </strong> Settle your repayment
                smoothly, with clear terms and zero hidden charges.
              </li>
              <li>
                <strong>3. Park for Free - </strong> Here's the innovation: even
                after repaying, you don't have to take your items back right
                away. You can leave them securely parked with us{" "}
                <strong>without paying a single kobo for storage</strong>.
              </li>
            </ul>
          </section>

          <section className="pawn-park-why">
            <h2>Why We Introduced Pawn & Park</h2>
            <p>
              Over the years, many of our customers told us they sometimes
              weren't ready to collect their items immediately after repaying.
              Whether due to travel, busy schedules, or simply needing extra
              time, they wanted a safe and trusted option.
            </p>
            <p>
              <strong>Pawn & Park was created as the answer.</strong>
            </p>
            <p>
              It's our way of making sure you enjoy not just quick financial
              relief, but also flexibility, security, and complete peace of
              mind.
            </p>
          </section>

          <section className="pawn-park-benefits">
            <h2>The Benefits of Pawn & Park</h2>
            <ul>
              <li>
                ✔️ <strong>Free Storage After Repayment</strong> - No extra
                cost, no extra stress.
              </li>
              <li>
                ✔️ <strong>Convenience on Your Terms</strong> - Collect your
                item when it's right for you.
              </li>
              <li>
                ✔️ <strong>Top-Notch Security</strong> - Your valuables stay
                protected under our trusted care.
              </li>
              <li>
                ✔️ <strong>Exclusive Service in Nigeria</strong> - Respected
                Solutions is one of the first to offer this kind of benefit.
              </li>
            </ul>
          </section>

          <section className="pawn-park-for">
            <h2>Who Is Pawn &amp; Park For?</h2>
            <ul>
              <li>▪️ Busy professionals who want flexibility.</li>
              <li>
                ▪️ Travelers who may not be in town immediately after repayment.
              </li>
              <li>
                ▪️ Anyone who values the peace of mind that comes with free,
                secure storage.
              </li>
            </ul>
          </section>

          <section className="pawn-park-standard">
            <h2>A New Standard in Lending</h2>
            <p>
              With Pawn & Park, Respected Solutions is raising the bar in
              Nigeria's financial services industry. We're not just offering
              loans, we're offering freedom, trust, and innovation that put
              customers first.
            </p>
            <p>
              This is more than a service. It's a new way to experience pawn
              lending.
            </p>
            <p>
              <strong>
                Welcome to Pawn & Park... only at Respected Solutions.
              </strong>
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};

export default PawnParkService;
